const ToastType = {
  SUCCESS: 0,
  ERROR: 1
}
export default ToastType
